import type { IconComponent } from '@alltrails/denali/components/Icon';
import DifficultyEasy from '@alltrails/denali/icons/DifficultyEasy';
import DifficultyHard from '@alltrails/denali/icons/DifficultyHard';
import DifficultyModerate from '@alltrails/denali/icons/DifficultyModerate';
import DifficultyStrenuous from '@alltrails/denali/icons/DifficultyStrenuous';
import type { ExploreServiceTrailDifficulty } from '../types/ExploreServiceFilters';

const icons: Record<ExploreServiceTrailDifficulty, IconComponent> = {
  easy: DifficultyEasy,
  moderate: DifficultyModerate,
  hard: DifficultyHard,
  strenuous: DifficultyStrenuous
};

const getDifficultyIcon = (difficulty: ExploreServiceTrailDifficulty): IconComponent => icons[difficulty];

export default getDifficultyIcon;
